import type { FnsLegalEntityDto } from '@/modules/counterparty/dto/fns-legal-entity.dto.ts';
import type { CounterpartyInnResult } from '@/modules/counterparty/types/counterparty-inn-result.type.ts';
import type { LegalForm } from '@/modules/counterparty/types/legal-form.type.ts';

function text(value?: string | number | null) {
  return value == null || value === '' ? '' : String(value);
}

export class CounterpartyInnAdapter {
  static matchLegalForm(name: string, forms: Pick<LegalForm, 'name'>[]) {
    return forms.reduce<string | null>((best, { name: formName }) => {
      if (!formName || !name.startsWith(formName)) {
        return best;
      }

      return !best || formName.length > best.length ? formName : best;
    }, null);
  }

  static map(response: FnsLegalEntityDto, legalForm: string | null): CounterpartyInnResult {
    return {
      name: response.short_name || response.full_name || '',
      inn: text(response.inn),
      legalForm,
      kpp: text(response.kpp) || null,
      ogrn: text(response.ogrn) || null,
    };
  }
}
